export default {
  maxPurchase: 6,
  eventTax: 0,
  customerFee: true,
  event_id: "",
  cart_tickets_attributes: [],
}
